<template>
  <div class="updMess" v-wechat-title="title">
    <van-cell-group class="inp-cell-group">
      <van-field maxlength="30" v-model="value" :placeholder="placeVal" @blur="input_blur" clearable @input="inputchange"/>
    </van-cell-group>
    <div class="btn">
      <button class="redBtn" :class="{grayBtn: value.replace(/ /g,'') ==''}" @click="submit">保存</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'updateMessage',
  data () {
    return {
      value: '',
      title: this.$route.query.type && this.$route.query.type === 'nickname' ? '修改昵称' : '修改姓名',
      placeVal: this.$route.query.type && this.$route.query.type === 'nickname' ? '请输入昵称' : '请输入姓名',
    }
  },
  mounted: function () {
    this.$route.meta.title = this.title
    var personInfo = JSON.parse(sessionStorage.getItem('personal_information'))
    switch (this.$route.query.type) {
      case 'nickname':
        this.value = personInfo.smallname
        break
      case 'name':
        this.value = personInfo.realname
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    submit: function () {
      var personInfo = JSON.parse(sessionStorage.getItem('personal_information'))
      if (this.value.replace(/ /g,'') !== '') {
        switch (this.$route.query.type) {
          case 'nickname':
            personInfo.smallname = this.value
                break
          case 'name':
            personInfo.realname = this.value
        }
        sessionStorage.setItem('personal_information', JSON.stringify(personInfo))
        this.$router.push('/perinfo')
      }
    },
    input_blur () {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    inputchange (val) {
      var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (val.match(reg)) {
        val = val.replace(reg, '')
      }
      val = val.replace(/\s+/g, '')
      this.value = val
    }
  }
}
</script>

<style scoped lang="scss">
  .updMess {
    /*min-height: 100%;*/
    .btn {
      width: 100%;
      padding: 0 0.11rem 0.1rem;
      position: fixed;
      bottom: 0;
      .redBtn {
        width: 100%;
        display: block;
        font-size:0.17rem;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:0.24rem;
        padding: 0.1rem 0;
        background:linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
        background: -webkit-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
        background: -o-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
        background: -moz-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
        background: -ms-linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%);
        border-radius:0.25rem;
        border: none;
        outline: none;
        &.grayBtn {
          background:#DDDDDD;
        }
      }
    }

  }
</style>
<style lang="scss">
  .updMess{
   .inp-cell-group {
    color: #E9EBF2;
    .van-cell {
      padding: 0.14rem 0.16rem;
      .van-field__control {
        color: #292929;
        font-size: 0.16rem;
        font-weight:400;
        line-height: 0.24rem;
        &::placeholder {
          color: #999999;
          font-size: 0.16rem;
          line-height: 0.24rem;
        }
      }
      .van-icon-clear {
        color: #E9EBF2;
      }
    }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/updateMessage.vue